import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IServiceError } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ErrorServiceService {
  constructor() {}

  private componentErrorMethodCallSource = new Subject<IServiceError>();

  public componentMethodCalled$ = this.componentErrorMethodCallSource.asObservable();

  public callErrorPopup(err: IServiceError): void {
    this.componentErrorMethodCallSource.next(err);
  }
}
